import "./static/assets/styles/global.scss"
